import { render, staticRenderFns } from "./entityDialogDis.vue?vue&type=template&id=09ccb856&"
import script from "./entityDialogDis.vue?vue&type=script&lang=js&"
export * from "./entityDialogDis.vue?vue&type=script&lang=js&"
import style0 from "./entityDialogDis.vue?vue&type=style&index=0&id=09ccb856&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports